import React from 'react';
import { Building2, UserPlus, QrCode, Smartphone } from 'lucide-react';
import LandingSection from './LandingSection';
import Reveal from './Reveal';
import { SIGNUP_URL } from './urls';
import { useT } from './i18n';

const stepIcons = [Building2, UserPlus, QrCode, Smartphone];

const LandingHowItWorks = () => {
  const t = useT();
  const steps = t('howItWorks.steps');

  return (
    <LandingSection id="ako-to-funguje" variant="gray">
      <Reveal>
        <h2 className="landing-h2" style={{ marginBottom: '2.5rem' }}>{t('howItWorks.title')}</h2>
      </Reveal>

      <ol className="landing-hiw-grid">
        {steps.map((step, index) => {
          const Icon = stepIcons[index];
          return (
            <li key={step.title} className="landing-hiw-card-wrap">
              <Reveal delay={index}>
                <div className="landing-hiw-card">
                  <div className="landing-hiw-card__head">
                    <span className="landing-hiw-card__num">{index + 1}</span>
                    <span className="landing-hiw-card__icon">
                      <Icon size={22} strokeWidth={1.75} aria-hidden />
                    </span>
                  </div>
                  <h3 className="landing-h4">{step.title}</h3>
                  <p className="landing-text" style={{ marginBottom: 0, fontSize: '0.9375rem' }}>
                    {step.description || (
                      <>
                        {step.descBefore}
                        <a href={SIGNUP_URL} className="landing-link">{step.linkText}</a>
                        {step.descAfter}
                      </>
                    )}
                  </p>
                </div>
              </Reveal>
            </li>
          );
        })}
      </ol>
    </LandingSection>
  );
};

export default LandingHowItWorks;
